var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/utils/equal.ts";
export function arrEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  return a.every((aItem, idx) => b[idx] === aItem);
}